// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comp-feature[data-v-0a613d7e]{width:100%;background-color:#fff}.comp-feature .cont[data-v-0a613d7e]{padding-bottom:.25rem}.comp-feature .cont img[data-v-0a613d7e]{display:block;width:100%;height:100%;margin:0 0}.comp-feature .cont p[data-v-0a613d7e]{margin:.05rem .3rem;color:#999;font-size:.24rem;line-height:.38rem}.comp-feature .cont .first[data-v-0a613d7e]{padding-top:.25rem}", ""]);
// Exports
module.exports = exports;
